<div class="modal-content">
    <div class="col-12 box-form border-custom p-5">
        <div class="row d-flex align-center justify-content-between">
            <h3 class="modal-title">Detalhes da Solicitação de Garantia</h3>
            <a (click)="closeModal()" class="closebtn">x</a>
        </div>
        <hr>
        <div class="row mt-2">
            <div class="text-left">
                <fieldset>
                    <legend>Dados Ativos</legend>
                    <p class="infoModal">Código Ativo: <b class="dataModal">{{data?.codigoAtivo}}</b></p>
                    <p class="infoModal">Data Aquisição: <b class="dataModal">{{data?.dataAquisicao | date: 'dd/MM/yyyy'}}</b></p>
                    <!-- <p>Data Vencimento: <b class="dataModal">{{data?.data}}</b></p> -->
                    <p class="infoModal">Valor Emissão Aquisição: <b class="dataModal">{{data?.valorInvestido | currency: 'BRL'}}</b></p>
                    <p class="infoModal">Corretora: <b class="dataModal">{{data?.nomeCorretora}}</b></p>
                </fieldset>
            </div>
        </div>
        <hr>
<!--        <div class="row mt-2">-->
<!--            <div class="text-left">-->
<!--                <fieldset>-->
<!--                    <legend>Dados Endereço</legend>-->
<!--                    <p class="infoModal">Endereço: <b class="dataModal">{{data?.endereco}}</b></p>-->
<!--                    <p class="infoModal">Complemento: <b class="dataModal">{{data?.complemento}}</b></p>-->
<!--                    <p class="infoModal">Bairro: <b class="dataModal">{{data?.bairro}}</b></p>-->
<!--                    <p class="infoModal">Cidade: <b class="dataModal">{{data?.cidade}}</b></p>-->
<!--                    <p class="infoModal">UF: <b class="dataModal">{{data?.estado}}</b></p>-->
<!--                    <p class="infoModal">CEP: <b class="dataModal">{{data?.cep}}</b></p>-->
<!--                </fieldset>-->
<!--            </div>-->
<!--        </div>-->
        <hr>
        <div class="row mt-2">
            <div class="text-left">
                <fieldset>
                    <legend>Dados Bancários</legend>
                    <p class="infoModal">Nome Banco: <b class="dataModal">{{data?.nomeBanco}}</b></p>
                    <p class="infoModal">Código Banco: <b class="dataModal">{{data?.codigoBanco}}</b></p>
                    <p class="infoModal">Tipo de Conta: <b class="dataModal">{{data?.tipoConta}}</b></p>
                    <p class="infoModal">Agência: <b class="dataModal">{{data?.agencia}}</b></p>
                    <p class="infoModal">Dígito Agência: <b class="dataModal">{{data?.dgAgencia}}</b></p>
                    <p class="infoModal">Conta: <b class="dataModal">{{data?.conta}}</b></p>
                    <p class="infoModal">Dígito Conta: <b class="dataModal">{{data?.dgConta}}</b></p>
                </fieldset>

            </div>
        </div>
        <hr>
        <div class="row mt-4">
            <div class="d-flex justify-content-cene">
                <button (click)="closeModal()" class="btn">Voltar</button>
            </div>
        </div>
    </div>
</div>
